import React from 'react'
import { connect } from 'react-redux'
import * as pt from 'prop-types'
import createReactClass from 'create-react-class'

import QuickFilters from './QuickFilters'
import DateFilters from './DateFilters'
import Pagination from './Pagination'
import actions from '../../redux/actions'
import { EVENT_VIEW_TYPES } from '../../redux/events/reducers'

var Navigator = createReactClass({
  propTypes: {
    isTop: pt.bool.isRequired,
    filters: pt.shape({
      startDateTime: pt.object.isRequired,
      stopDateTime: pt.object.isRequired,
    }).isRequired,
    onFilterChange: pt.func.isRequired,
    encoders: pt.object.isRequired,
    onSettingsToggle: pt.func.isRequired,
    pagination: pt.object.isRequired,
    disabled: pt.bool.isRequired,
    dateFiltersDisabled: pt.bool,
  },

  getDefaultProps: function () {
    return {
      dateFiltersDisabled: false,
    }
  },

  shouldComponentUpdate: function (nextProps, nextState) {
    return this.props !== nextProps
  },

  openSettings: function (ev) {
    ev.preventDefault()
    this.props.onSettingsToggle()
  },

  handleFilterChange: function (params) {
    // check that incoming dates have a valid range before changing
    if (
      (params.startDateTime && params.startDateTime <= this.props.filters.stopDateTime) ||
      (params.stopDateTime && params.stopDateTime >= this.props.filters.startDateTime)
    ) {
      this.props.onFilterChange({
        type: 'change',
        params: params,
      })
    }
  },

  resetFilters: function (ev) {
    ev.preventDefault()
    this.props.onFilterChange({
      type: 'reset',
    })

    if(this.props.filters.techID) { // since the techID must be undefined to not be included in the filter call, we need to explicitly set it to undefined
        this.props.onFilterChange({
            type: 'change',
            params: { techID: undefined },
        })
    }
  },

  render: function () {
    var props = this.props

    var paginationNavigation =
      this.props.pagination.totalPages > 1 ? (
        <Pagination {...this.props.pagination} disabled={this.props.disabled} />
      ) : null
    var style = {
      opacity: this.props.disabled ? '0.4' : 'initial',
    }

    function handleClick(ev) {
      if (props.disabled) {
        ev.preventDefault()
      }
    }

    if (props.eventViewType === EVENT_VIEW_TYPES.CALENDAR.key) {
      return null
    }
    return (
      <>
        <div style={{ display: 'flex' }}>
          {paginationNavigation ? paginationNavigation : null}
        </div>
        <div
          className='event-listing-navigator hidden-print'
          onClick={handleClick}
          style={style}
        >
          <div className='navigator-settings'>
            <div className='date-filters'>
              {this.props.searchComponent}
              <QuickFilters
                filters={this.props.filters}
                isTop={this.props.isTop}
                onChange={this.handleFilterChange}
                disabled={this.props.disabled}
                style={this.props.isTop ? { zIndex: 2 } : { zIndex: 1 }}
              />
            </div>
          </div>
          <div className='settings-toggle-area'>
            <button
              type='button'
              className='btn btn-default'
              disabled={this.props.disabled}
              id='filter-remove-icon'
              onClick={this.resetFilters}
            >
              Reset Filters
            </button>
            <button
              type='button'
              disabled={this.props.disabled}
              className='btn btn-default'
              onClick={this.openSettings}
            >
              <i className='fa fa-cog' />
            </button>
          </div>
        </div>
      </>
    )
  },
})

const mergeProps = (stateProps, _dispatchProps, ownProps) => {
  const dispatch = func => _dispatchProps.callDispatch(func)
  const onPageChange = page => dispatch(actions.data.pageChange({page}))
  stateProps.pagination.onPageChange = onPageChange
  return { ...ownProps, ...stateProps }
}

const mapStateToProps = state => {
  const pagination = state.data.eventsMeta || { totalPages: 0, currentPage: 0 }
  return { pagination }
}

const mapDispatchToProps = dispatch => ({
  callDispatch: func => dispatch(func),
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Navigator)
